"use client";

import { useState } from "react";
import Image from "next/image";

interface YoutubeEmbedProps {
  videoId: string;
  title: string;
  className?: string;
}

export default function YoutubeEmbed({ videoId, title, className = "" }: YoutubeEmbedProps) {
  const [loaded, setLoaded] = useState(false);

  if (loaded) {
    return (
      <iframe
        width="100%"
        height="100%"
        src={`https://www.youtube-nocookie.com/embed/${videoId}?autoplay=1`}
        title={title}
        frameBorder="0"
        allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture"
        allowFullScreen
        className={`absolute inset-0 ${className}`}
      />
    );
  }

  return (
    <button
      type="button"
      className="absolute inset-0 w-full h-full group"
      onClick={() => setLoaded(true)}
      aria-label={`Reproduzir: ${title}`}
    >
      <Image
        src={`https://img.youtube.com/vi/${videoId}/hqdefault.jpg`}
        alt={title}
        fill
        className="object-cover"
      />
      <span className="absolute inset-0 flex items-center justify-center bg-black/30 group-hover:bg-black/40 transition-colors">
        <span className="w-16 h-16 bg-white rounded-full flex items-center justify-center">
          <svg width="24" height="24" viewBox="0 0 24 24" fill="currentColor" className="text-blue-main ml-1">
            <path d="M8 5v14l11-7z" />
          </svg>
        </span>
      </span>
    </button>
  );
}
